// declare var SimpleBar;

// namespace AgerLMS.WebSite {

//     export interface ClassesJsWidgetRequest {
//         items: ClassesItem[];
//     }

//     @Serenity.Decorators.registerClass()
//     export class ClassesJsWidget extends Serenity.Widget<ClassesJsWidgetRequest> {

//         constructor(element: JQuery, opt: ClassesJsWidgetRequest) {
//             super(element, opt);

//             opt.items.forEach(item => {
//                 var itemUrl = item.ItemUrl;
//                 var itemThumbnailImage = item.ItemThumbnailImage;
//                 var card = this.createWebinarCard(item, itemUrl, itemThumbnailImage, null);
//                 card.appendTo(this.element);
//             }
//         }

//         createWebinarCard(item : ClassesItem, itemUrl : any, itemThumbnailImage : any, urlHelper : any) : JQuery
//         {
//             var publishDate = item.PublishDate || item.InsertDate;
//             // var durationString = "getDuration(item.Duration)";
//             // var type = "Ager.TypeKeyStringToDescription(item.Type)";
//             var durationString = "";
//             var type = "";
        
//             var cardDiv = $('<div class="webinar-card"></div>');
//             var figure = $('<figure></figure>');
//             var link = $('<a href="' + urlHelper.Content(itemUrl) + '"></a>');
//             var imageBox = $('<div class="image-box"></div>');
        
//             if (type !== "Kitaplar") {
//                 $('<span class="badge mia-badge">' + type + '</span>').appendTo(imageBox);
//             }
        
//             $('<img src="' + urlHelper.Content(itemThumbnailImage) + '" class="img-cover" alt="' + item.ItemName + '" />').appendTo(imageBox);
//             imageBox.appendTo(link);
//             link.appendTo(figure);
        
//             var figcaption = $('<figcaption class="webinar-card-body"></figcaption>');
//             var titleLink = $('<a href="' + urlHelper.Content(itemUrl) + '" title="' + item.ItemName + '"></a>');
//             var titleH3 = $('<h3 class="mt-5 webinar-title font-weight-bold font-16 text-dark-blue">' + item.ItemName + '</h3>');
        
//             titleH3.appendTo(titleLink);
//             titleLink.appendTo(figcaption);
        
//             if (!(item.Type === "Books" || item.Type === "Bundle")) {
//                 var dFlexDiv = $('<div class="d-flex justify-content-between mt-5"></div>');
//                 var durationDiv = $('<div class="d-flex align-items-center"></div>');
        
//                 $('<i width="20" height="20" data-feather="clock" class="webinar-icon"></i>').appendTo(durationDiv);
//                 $('<span class="duration font-14 ml-5">' + durationString + '</span>').appendTo(durationDiv);
//                 durationDiv.appendTo(dFlexDiv);
        
//                 $('<div class="vertical-line mx-15"></div>').appendTo(dFlexDiv);
        
//                 var dateDiv = $('<div class="d-flex align-items-center"></div>');
//                 $('<i width="20" height="20" data-feather="calendar" class="webinar-icon"></i>').appendTo(dateDiv);
//                 $('<span class="date-published font-14 ml-5">' + publishDate.toDateString() + '</span>').appendTo(dateDiv);
//                 dateDiv.appendTo(dFlexDiv);
        
//                 dFlexDiv.appendTo(figcaption);
//             } else {
//                 $('<div class="d-flex justify-content-between mt-5"><div class="d-flex align-items-center">&nbsp;</div></div>').appendTo(figcaption);
//             }
        
//             var priceBoxDiv = $('<div class="webinar-price-box mt-10"></div>');
//             if (item.Price === 0) {
//                 $('<span class="real font-14">Açık Erişim</span>').appendTo(priceBoxDiv);
//             } else {
//                 $('<span class="real">' + item.Price + '</span>').appendTo(priceBoxDiv);
//             }
//             priceBoxDiv.appendTo(figcaption);
        
//             var dFlexDiv2 = $('<div class="d-flex justify-content-between mt-10"></div>');
//             var instructorSpan = $('<span class="instructor-item d-block font-14 mt-10"><a href="' + urlHelper.Content(item.InsertUser.ProfileUrl) + '" target="_blank" class="text-decoration-underline">' + item.InsertUser.DisplayName + '</a></span>');
//             var verticalLineDiv2 = $('<div class="vertical-line mx-15"></div>');
//             var categorySpan = $('<span class="d-block font-14 mt-10"><a href="' + urlHelper.Content('~/kategori/' + item.CategoryName.ToSeoUrl()) + '" target="_blank" class="text-decoration-underline">' + item.CategoryName + '</a></span>');
        
//             instructorSpan.appendTo(dFlexDiv2);
//             verticalLineDiv2.appendTo(dFlexDiv2);
//             categorySpan.appendTo(dFlexDiv2);
//             dFlexDiv2.appendTo(figcaption);
        
//             figcaption.appendTo(figure);
//             figure.appendTo(cardDiv);
        
//             return cardDiv;
//         }
//     }

//     class ClassesItem {
//         Id: number;
//         TypeKey: string;
//         Type: string;
//         EntityType: EntityTypes;
//         ParentId?: number;
//         Description: string;
//         ItemName: string;
//         ItemUrl: string;
//         ItemFullUrl: string;
//         InsertDate?: Date;
//         PublishDate?: Date;
//         ProfileUrl: string;
//         CategoryId?: number;
//         CategoryName: string;
//         Price?: number;
//         SalePrice?: number;
//         ItemCoverImage: string;
//         ItemThumbnailImage: string;
//         Discount?: number;
//         ItemVideoSource: string;
//         ItemVideoUrl: string;
//         Duration?: number;
//         UsagePeriod?: number;
//         WatchCount?: number;
//         SalesStatus?: number;
//         IncludesCargoPrice?: boolean;
//         StartDate?: Date;
//         EndDate?: Date;
//         InsertUser: UserItem;
//     }

//     class UserItem {
//         UserGroup?: UserGroups | null;
//         DisplayName: string;
//         Email: string;
//         ProfileUrl: string;
//         Bio: string;
//         JobTitle: string;
//         UserId?: number | null;
//         ItemCoverImage: string;
//         ItemThumbnailImage: string;
//     }
    
//     enum UserGroups {
//         // UserGroups enum'unun değerleri buraya eklenir.
//         // Örnek olarak:
//         Admin,
//         Moderator,
//         RegularUser,
//         // ...
//     }

//     enum EntityTypes {
//         // EntityTypes enum'unun değerleri buraya eklenir.
//         // Örnek olarak:
//         Blog,
//         Product,
//         // ...
//     }
// }